import React from "react";
import { WrapPageElementBrowserArgs, WrapRootElementBrowserArgs } from "gatsby";

import Layout from "./layout";

function wrapRootElement({ element }: WrapRootElementBrowserArgs) {
  return <>{element}</>;
}

function wrapPageElement({ element, props }: WrapPageElementBrowserArgs) {
  return <Layout {...(props as any)}>{element}</Layout>;
}

export { wrapRootElement, wrapPageElement };